module.exports = __webpack_public_path__ + "media/src/images/icons/arrow_clock-5a5cd44c6d9001d544fc770343280940.svg";